<template>
<div class="page-data-list">
    <el-row :gutter="20">
      <el-col :span="8">
        <div>
            <el-statistic title="在线设备数">
            <template slot="formatter"> 0台 </template>
          </el-statistic>
        </div>
      </el-col>
      <el-col :span="8">
        <div>
          <el-statistic title="注册设备数">
            <template slot="formatter"> 456台 </template>
          </el-statistic>
        </div>
      </el-col>
      <el-col :span="8">
        <div>
            <el-statistic title="男女比">
            <template slot="formatter"> 456/2 </template>
          </el-statistic>
        </div>
      </el-col>
      
    </el-row>
</div>
</template>

<script>
  import notFundData from '@client/components/notFundData'
	export default {
		components: {
			notFundData
        },
        data() {
      return {
        like: true,
        value1: 4154.564,
        value2: 2222,
        title: '今年的增长',
      };
    },
	}
</script>

<style scoped>
.page-data-list{
  height: 100%;
}
</style>
